import { FC } from "react";
import { useTheme } from "../context/ThemeContext";

interface InfoBoxProps {
  heading: string;
  body: string;
  className?: string;
}

const InfoBox: FC<InfoBoxProps> = (props) => {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  
  return (
    <div
      className={`mb-5 text-gray-800 dark:text-white ${props.className}`}
      role="alert"
    >
      <p className="font-bold">{props.heading}</p>
      <p className={isLightMode ? "text-gray-800" : "text-gray-300"}>{props.body}</p>
    </div>
  );
};

export default InfoBox;
